import { ReactNode } from 'react'
import ChartSkeleton from '../chart/ChartSkeleton'
import { ChartErrorState } from '../chart/ChartErrorState'

type ChartQueryStatus = 'pending' | 'success' | 'error'

interface ChartQueryStateProps<TData> {
  query: {
    status: ChartQueryStatus | string
    error: unknown
    data: TData | undefined
  }
  skeleton?: ReactNode
  children: (data: TData) => ReactNode
}

export function ChartQueryState<TData>({ query, skeleton, children }: ChartQueryStateProps<TData>) {
  const { status, error, data } = query

  if (status === 'pending') {
    return skeleton ?? <ChartSkeleton variant="horizontal" />
  }

  if (error !== null && error !== undefined) {
    return <ChartErrorState error={error} />
  }

  if (status === 'success' && data !== undefined) {
    return children(data)
  }

  return null
}
